import { translate } from 'src/i18n/translate';

export function alertSomethingWentWrongCheckYourInternetConnectionOrContactSupport(): void {
    alert(translate('Something went wrong. Check your internet connection and try again. If the problem persists please contact the support.'));
}
